'use client'

import {
	Carousel,
	CarouselApi,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '@qr-front/ui/components/Carousel'
import { cn } from '@qr-front/ui/utils'
import { CheckoutRouteType } from 'features/purchase/purchaseState'
import { useState } from 'react'

import { TestimonialCard, TTestimonial } from './TestimonialsGrid'

const DESKTOP_MEDIA_QUERY = '(min-width: 1220px)'

export const TestimonialsCarousel = ({
	testimonials,
	routeType,
	className,
	threeUpOnDesktop = false,
}: {
	testimonials: TTestimonial[]
	routeType?: CheckoutRouteType
	className?: string
	threeUpOnDesktop?: boolean
}) => {
	const [, setApi] = useState<CarouselApi>()

	if (!testimonials.length) {
		return null
	}

	return (
		<div className={cn('mt-6 tablet:mt-16 desktop:mt-16', className)}>
			<Carousel
				setApi={setApi}
				opts={{
					align: 'start',
					loop: true,
					...(threeUpOnDesktop && {
						breakpoints: {
							[DESKTOP_MEDIA_QUERY]: { slidesToScroll: 3 },
						},
					}),
				}}
			>
				<div className="relative">
					<CarouselContent
						className={cn(threeUpOnDesktop && 'desktop:-ml-8')}
					>
						{testimonials.map((testimonial) => (
							<CarouselItem
								key={testimonial.description}
								className={cn(
									threeUpOnDesktop &&
										'desktop:basis-1/3 desktop:pl-8',
								)}
							>
								<TestimonialCard
									testimonial={testimonial}
									showUserAvatar={false}
									showStars
									className="h-full"
									routeType={routeType}
								/>
							</CarouselItem>
						))}
					</CarouselContent>

					<CarouselPrevious
						visual="soft"
						iconClassName="text-dark-grey group-hover:text-white"
						className="group absolute -left-18 top-1/2 hidden -translate-y-1/2 hover:bg-black hover:ring-black [@media(min-width:1400px)]:flex"
					/>
					<CarouselNext
						visual="soft"
						iconClassName="text-dark-grey group-hover:text-white"
						className="group absolute -right-18 top-1/2 hidden -translate-y-1/2 hover:bg-black hover:ring-black [@media(min-width:1400px)]:flex"
					/>
				</div>

				<div className="mt-6 flex justify-center gap-[11px] tablet:gap-2 [@media(min-width:1400px)]:hidden">
					<CarouselPrevious
						visual="soft"
						iconClassName="text-dark-grey group-hover:text-white"
						className="group h-10 w-10 hover:bg-black hover:ring-black"
					/>
					<CarouselNext
						visual="soft"
						iconClassName="text-dark-grey group-hover:text-white"
						className="group h-10 w-10 hover:bg-black hover:ring-black"
					/>
				</div>
			</Carousel>
		</div>
	)
}
